import React from 'react'
import FontAwesome from 'react-fontawesome'

const RadiosField = (field) => {
    const { label, name, input, fields = [], initialValue, hideError, meta: { error, touched }, labelClassName = 'radio inline' } = field
    const onClick = (value, field) => {
        if (field.onChange) field.onChange(value)
        return input.onChange(input.value = value)
    }
    return (
        <span>
            { label ? <h5>{ label }</h5> : null }
            {
                fields.map((field, index) =>
                    <label className={ labelClassName } key={ `radio-${name}-${index}` }>
                        <input 
                            type='radio'
                            name={ input.name }
                            value={ field.value }
                            onClick={ onClick.bind(this, field.value, field) }
                            defaultChecked={ initialValue === field.value }
                        />
                        {
                            field.icon &&
                                <span>
                                    <FontAwesome name={ field.icon } />&nbsp;
                                </span>
                        }
                        <span>
                            { field.label }
                        </span>
                        { field.small ? <div className='radio-field-small'><small>{ field.small }</small></div> : null }
                    </label>
                )
            }
            { !hideError && touched && ((error && <p className='error'>{error}</p>)) }
        </span>
    )
}

export default RadiosField


// WEBPACK FOOTER //
// ./src/client/features/form/components/RadiosField.jsx